// MOCK DATA ONLY. Backs the Location Repository list page — a browsable
// history of previously-visited cities (CLAUDE.md Section 26/19).
const tspLocationsMockData = {
  records: [
    { id: "loc1", city: "Jaipur", state: "Rajasthan", visits: 4, lastVisited: "Nov 18, 2025", avgRating: 4.8, totalBooks: 890 },
    { id: "loc2", city: "Ajmer", state: "Rajasthan", visits: 3, lastVisited: "Nov 21, 2025", avgRating: 4.7, totalBooks: 420 },
    { id: "loc3", city: "Pushkar", state: "Rajasthan", visits: 2, lastVisited: "Nov 23, 2025", avgRating: 4.9, totalBooks: 310 },
    { id: "loc4", city: "Ahmedabad", state: "Gujarat", visits: 5, lastVisited: "Nov 25, 2025", avgRating: 4.6, totalBooks: 1240 },
    { id: "loc5", city: "Mumbai", state: "Maharashtra", visits: 6, lastVisited: "Jul 30, 2025", avgRating: 4.5, totalBooks: 1580 },
    { id: "loc6", city: "Chennai", state: "Tamil Nadu", visits: 3, lastVisited: "Aug 25, 2025", avgRating: 4.7, totalBooks: 780 },
  ],
};

export default tspLocationsMockData;
